'use client'

import { useTranslation } from 'react-i18next'
import { createIcon } from '@/components/icons/createIcon'
import Logo from '@/components/logo'

// 创建 404 图标
const NotFound404Icon = createIcon(
  'NotFound404',
  [
    [
      'path',
      {
        d: 'M39.5 42v7.4H36V55h-8.1v-5.6H12V42l11.15-22h8.6L20.6 42h7.3v-7.5H36V42h3.5Zm29.2 8.75c-2.5 3.3-5.98 4.95-10.45 4.95-4.46 0-7.96-1.65-10.5-4.95C45.25 47.42 44 43 44 37.5s1.25-9.9 3.75-13.2c2.54-3.33 6.04-5 10.5-5 4.47 0 7.95 1.67 10.45 5 2.54 3.3 3.8 7.7 3.8 13.2 0 5.5-1.26 9.92-3.8 13.25ZM52 37.5c0 6.93 2.09 10.4 6.25 10.4 4.17 0 6.25-3.47 6.25-10.4s-2.08-10.4-6.25-10.4C54.1 27.1 52 30.57 52 37.5Zm55.92 10.55-2.56 6.94-3.28-1.2-1.93 5.25-7.6-2.8 1.93-5.26-14.92-5.49 2.56-6.94 18.06-16.8 8.07 2.98-18.06 16.79 6.85 2.52L99.63 37l7.6 2.8-2.6 7.04 3.3 1.2Z',
        fill: 'currentColor'
      }
    ],
    [
      'path',
      {
        d: 'M75.63 19.17c2.16-.5 7.6-.2 12 5',
        stroke: 'var(--color-blue)',
        strokeDasharray: '2 2',
        strokeLinecap: 'round',
        strokeWidth: '1.5'
      }
    ]
  ],
  '0 0 120 80',
  120,
  80
)

export default function NotFound() {
  const { t } = useTranslation()

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center bg-gradient-to-r from-[#F1F9FF] to-[#FFFBF3] dark:from-background dark:to-background">
      {/* Logo */}
      <div className="absolute left-5 top-3">
        <Logo className="text-content-primary" />
      </div>

      {/* 404 Content */}
      <div className="flex flex-col items-center gap-5">
        <NotFound404Icon className="text-content-primary" />
        <p className="text-xl font-medium leading-[30px] text-content-primary">
          {t('Base.NotFoundErrors')}
        </p>
      </div>
    </div>
  )
}
